module.exports = __webpack_public_path__ + "img/supporting_doc_active.e9286532.svg";